import { School } from "@gradience/api-types";

const brandNames: Record<string, string> = {
  amex: "American Express",
  diners: "Diners Club",
  discover: "Discover",
  jcb: "JCB",
  mastercard: "Mastercard",
  unionpay: "UnionPay",
  visa: "Visa",
};

/**
 * e.g. "Visa ending in 4242"
 */
export const displayPaymentMethod = (
  paymentMethod: NonNullable<School["paymentMethod"]>
) => {
  const brand = paymentMethod.brand
    ? (brandNames[paymentMethod.brand] ?? paymentMethod.brand)
    : "Card";

  return paymentMethod.last4
    ? `${brand} ending in ${paymentMethod.last4}`
    : brand;
};

/**
 * e.g. "Expires 04/28", or undefined for payment methods without an expiry
 */
export const displayPaymentMethodExpiry = (
  paymentMethod: NonNullable<School["paymentMethod"]>
) =>
  paymentMethod.expMonth && paymentMethod.expYear
    ? `Expires ${String(paymentMethod.expMonth).padStart(2, "0")}/${String(paymentMethod.expYear).slice(-2)}`
    : undefined;
